module.exports = __webpack_public_path__ + "static/media/full_team.7844eb95.JPG";